import React from "react";
import RenderCalendlyLinks from "../../components/common/RenderCalendlyLinks";
import NewProductTemplate from "../../components/sections/product-more-info/Item";
import { cn } from "../../utils/cn";
import Emoji from "../../utils/emoji";
import ProductTemplate from "./product";

const Product = (props) => {
    const { pageContext } = props;
    const { item } = pageContext;

    const newProductsEnabled =
        process.env.GATSBY_NEW_PRODUCTS_ENABLED === "true";

    const Data = () => {
        return (
            <section className="max-w-xl text-left font-inter text-gray-500">
                <p className="font-semibold">
                    Certificat Mèdic Oficial — GUB i Policies Locals
                </p>

                <p className="mt-3">
                    El <strong>Certificat Mèdic Oficial</strong> és un requisit
                    obligatori per presentar-te a les oposicions de{" "}
                    <strong>Guàrdia Urbana de Barcelona</strong> i{" "}
                    <strong>Policies Locals</strong>. A iOpos t’oferim la
                    possibilitat d’obtenir-lo de manera <strong>ràpida</strong>,{" "}
                    <strong>senzilla</strong> i{" "}
                    <strong>totalment vàlida</strong>, sense complicacions ni
                    desplaçaments innecessaris.
                </p>

                <p className="mt-3">
                    Aquest certificat acredita que compleixes les{" "}
                    <strong>condicions mèdiques exigides</strong> per participar
                    en el procés selectiu.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🩺" label="revisió mèdica" /> Què inclou el
                    certificat?
                </h2>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        Revisió mèdica completa segons els criteris oficials.
                    </li>
                    <li>
                        Emissió del Certificat Mèdic Oficial vàlid per a
                        oposicions.
                    </li>
                    <li>Atenció ràpida i professional.</li>
                    <li>
                        Document lliurat llest per presentar a la convocatòria.
                    </li>
                </ul>

                <p className="mt-3">
                    El certificat compleix amb els requisits establerts a les{" "}
                    <strong>bases oficials</strong> de les convocatòries.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="📍" label="ubicació" /> On es realitza?
                </h2>

                <p className="mt-5">
                    La revisió mèdica i l’emissió del certificat es realitzen a
                    través de <strong>Badamedic</strong>, centre mèdic
                    col·laborador d’iOpos, especialitzat en certificats mèdics
                    oficials.
                </p>

                <p>Badamedic garanteix:</p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>Professionals acreditats.</li>
                    <li>Procediment ràpid i eficient.</li>
                    <li>Compliment estricte de la normativa vigent.</li>
                </ul>

                <p className="mt-3">
                    La visita es realitza sempre amb{" "}
                    <strong>cita prèvia</strong>, que es realitza desde la web
                    de iOpos.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="📄" label="documentació" /> Documentació
                    necessària
                </h2>

                <p className="mt-5">El dia de la visita mèdica cal portar:</p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        Document d’identitat original (
                        <strong>DNI, NIE o passaport</strong>
                        ).
                    </li>
                    <li>
                        L’escrit de les{" "}
                        <strong>bases de la convocatòria</strong>.
                    </li>
                    <li>
                        La <strong>fulla del certificat mèdic oficial</strong>{" "}
                        adquirida a l’estanc.
                    </li>
                </ul>

                <p className="mt-3">
                    Sense aquesta documentació, el centre mèdic pot{" "}
                    <strong>no emetre el certificat</strong>.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="⏱" label="validesa" /> Validesa del
                    certificat
                </h2>

                <p className="mt-5">
                    La validesa del certificat dependrà del que estableixin les{" "}
                    <strong>bases de cada convocatòria</strong>. Es recomana
                    revisar sempre els terminis oficials abans de presentar la
                    documentació per assegurar-te que el certificat és vigent.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="💸" label="preu" /> Preu del certificat
                </h2>

                <p className="mt-5">
                    El preu del <strong>Certificat Mèdic Oficial</strong> és de:
                </p>

                <p className="mt-2 text-lg font-semibold text-ccyan-dark">
                    29,99&nbsp;€
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🔁" label="renovacions" /> Condició especial
                    per a renovacions
                </h2>

                <p className="mt-5">
                    Si necessites nous certificats mèdics en un termini{" "}
                    <strong>inferior a 6 mesos</strong>, aquests només tindran
                    un cost de <strong>5&nbsp;€</strong>, sempre que s’hagin
                    emès a través d’iOpos.
                </p>

                <p className="mt-3">
                    Aquesta condició està pensada per facilitar la presentació
                    del certificat en{" "}
                    <strong>diferents processos selectius</strong> dins del
                    mateix període.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🎯" label="resum" /> En resum
                </h2>

                <p className="mt-5">
                    Una forma <strong>còmoda, ràpida i econòmica</strong>{" "}
                    d’obtenir el <strong>Certificat Mèdic Oficial</strong>{" "}
                    necessari per a les oposicions de GUB i Policies Locals, amb{" "}
                    <strong>avantatges especials</strong> si necessites
                    renovar-lo en poc temps.
                </p>

                <p className="mt-5 rounded-md border border-yellow-300 bg-yellow-50 p-4 text-sm text-yellow-800">
                    <strong>Importante:</strong> Revisa tu certificado médico
                    antes de salir del centro. Comprueba que aparecen
                    correctamente tu nombre y apellidos, DNI/NIE, la firma del
                    médico y el sello del centro, y que el documento cumple los
                    requisitos exigidos por la convocatoria a la que te
                    presentas.
                </p>

                <RenderCalendlyLinks
                    stock={item.stock}
                    calendly_schedule={item.calendly_schedule}
                />
            </section>
        );
    };

    return (
        <>
            {!newProductsEnabled ? (
                <ProductTemplate item={item}>
                    <Data />
                </ProductTemplate>
            ) : (
                <NewProductTemplate
                    item={item}
                    title="Cuida la teva salut i prepara't per a les oposicions amb la revisió mèdica més completa i accessible a Badamedic!"
                >
                    <Data />
                </NewProductTemplate>
            )}
        </>
    );
};

export default Product;

const styles = {
    strong: "font-semibold text-ccyan",
    title: "font-bold text-xl font-montserrat",
    list: "list-disc ml-4",
};
